/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const FILE_VIEWBOX = 24;

const FILE_PATH =
  'M20 8.94C19.9896 8.84813 19.9695 8.75763 19.94 8.67V8.58C19.8919 8.47718 19.8278 8.38267 19.75 8.3L13.75 2.3C13.6673 2.22222 13.5728 2.15808 13.47 2.11H13.38L13.06 2H7C6.20435 2 5.44129 2.31607 4.87868 2.87868C4.31607 3.44129 4 4.20435 4 5V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V9C20 9 20 9 20 8.94ZM14 5.41L16.59 8H14V5.41ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H12V9C12 9.26522 12.1054 9.51957 12.2929 9.70711C12.4804 9.89464 12.7348 10 13 10H18V19Z';

/**
 * Document / file (24×24). Color via `currentColor`.
 * Pass `aria-label` when icon conveys meaning without adjacent text.
 */
const FileIcon = ({
  size = 24,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${FILE_VIEWBOX} ${FILE_VIEWBOX}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={['ds-icon', className].filter(Boolean).join(' ')}
      aria-hidden={ariaLabel ? undefined : ariaHidden}
      aria-label={ariaLabel || undefined}
      role={ariaLabel ? 'img' : undefined}
      focusable="false"
      {...props}
    >
      <path d={FILE_PATH} fill="currentColor" />
    </svg>
  );
};

FileIcon.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default FileIcon;
